import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Badge,
  Avatar,
  Divider,
  ListItemIcon,
  List,
  ListItem,
  ListItemText,
  Button,
  Chip,
} from '@mui/material';
import {
  NotificationsNoneOutlined as NotificationsIcon,
  LanguageOutlined as LanguageIcon,
  Menu as MenuIcon,
  SettingsOutlined as SettingsIcon,
  PersonOutlineOutlined as PersonIcon,
  LogoutOutlined as LogoutIcon,
  ChatBubbleOutlineOutlined as MessageIcon,
  DraftsOutlined as DraftsIcon,
} from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Switch, CircularProgress } from '@mui/material';
import { toast } from 'react-toastify';
const AppHeader = ({ isMobile, handleDrawerToggle }) => {
  const { user, setUser, logout, profile } = useAuth();
  const navigate = useNavigate();

  const [anchorElUser, setAnchorElUser] = useState(null);
  const [anchorElNotif, setAnchorElNotif] = useState(null);
  const [anchorElMessages, setAnchorElMessages] = useState(null);

  const [unreadMessages, setUnreadMessages] = useState([]);
  const [isStatusLoading, setIsStatusLoading] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem('token');

  const availability = Number(user?.profile?.availability_user ?? 0);

  const isOnline = availability === 1;
  // Récupérer les messages
  const fetchMessages = async () => {
    try {
      const res = await axios.get(`${apiUrl}/admin/public/g/c/l/a/contact`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // On filtre les nouveaux messages (statut 'pending')
      const pending =
        res.data.result?.filter((c) => c.status === 'pending') || [];
      setUnreadMessages(pending);
    } catch (err) {
      console.error('Erreur chargement messages header', err);
    }
  };
  const fetchProfile = async () => {
    try {
      const res = await axios.get(`${apiUrl}/intervenant/user/profile`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });

      const data = res.data.profile;

      const userData = {
        id: data.id_user,
        name: data.nom_user,
        role: data.role_user,
        profile: data,
      };

      setUser(userData);
      localStorage.setItem('user', JSON.stringify(userData));
    } catch (err) {
      console.error('Profile error', err);
    }
  };
  useEffect(() => {
    if (user) {
      fetchMessages();
      const interval = setInterval(fetchMessages, 60000); // Refresh toutes les minutes
      return () => clearInterval(interval);
    }
  }, [user, apiUrl, token]);
  if (!user) return null;

  const isIntervenant = Number(profile?.role_user) === 3;
  const handleToggleStatus = async () => {
    const previousStatus = Number(user?.profile?.availability_user);
    const newStatus = previousStatus === 1 ? 0 : 1;

    setIsStatusLoading(true);

    try {
      const res = await axios.post(
        `${apiUrl}/intervenant/intervenant/status/${profile.id_user}`,
        { availability_user: newStatus },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      console.log('API SUCCESS:', res.data);

      await fetchProfile();

      toast.success(res.data?.message || 'Statut mis à jour');
    } catch (err) {
      console.error('API ERROR:', err);

      // 🔥 Gestion propre des erreurs backend
      const errorMessage =
        err.response?.data?.message || // message API
        err.response?.data?.error || // fallback API
        err.message || // axios error
        'Erreur inconnue';

      const statusCode = err.response?.status;

      toast.error(`Erreur (${statusCode || 'N/A'}) : ${errorMessage}`);
    } finally {
      setIsStatusLoading(false);
    }
  };

  const pulseAnimation = {
    '@keyframes pulse': {
      '0%': { boxShadow: '0 0 0 0px rgba(5, 205, 153, 0.4)' },
      '70%': { boxShadow: '0 0 0 6px rgba(5, 205, 153, 0)' },
      '100%': { boxShadow: '0 0 0 0px rgba(5, 205, 153, 0)' },
    },
    '@keyframes pulseOffline': {
      '0%': { boxShadow: '0 0 0 0px rgba(244, 67, 54, 0.4)' },
      '70%': { boxShadow: '0 0 0 6px rgba(244, 67, 54, 0)' },
      '100%': { boxShadow: '0 0 0 0px rgba(244, 67, 54, 0)' },
    },
  };
  const statusPulse = {
    '@keyframes pulse-green': {
      '0%': {
        transform: 'scale(0.95)',
        boxShadow: '0 0 0 0 rgba(5, 205, 153, 0.7)',
      },
      '70%': {
        transform: 'scale(1)',
        boxShadow: '0 0 0 10px rgba(5, 205, 153, 0)',
      },
      '100%': {
        transform: 'scale(0.95)',
        boxShadow: '0 0 0 0 rgba(5, 205, 153, 0)',
      },
    },
  };
  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: 'transparent',
        boxShadow: 'none',
        padding: isMobile ? '8px 16px' : '20px 24px 0px 24px',
        width: '100%',
        left: 0,
      }}
    >
      <Toolbar
        sx={{
          justifyContent: 'space-between',
          backgroundColor: '#fff',
          color: '#1a2027',
          borderRadius: isMobile ? '12px' : '16px',
          border: '1px solid #eceef0',
          boxShadow: '0px 4px 12px rgba(0,0,0,0.05)',
          px: { xs: 1, sm: 3 },
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {isMobile && (
            <IconButton
              onClick={handleDrawerToggle}
              sx={{ mr: 1, color: '#5f6368' }}
            >
              <MenuIcon />
            </IconButton>
          )}
          <Typography variant="h6" sx={{ fontWeight: 800, fontSize: '1.1rem' }}>
            Plateforme{' '}
            <span style={{ fontWeight: 400, color: '#666' }}>SOA</span>
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: { xs: 0.5, sm: 1.5 },
          }}
        >
          {/* --- MENU MESSAGES --- */}
          <IconButton
            onClick={(e) => setAnchorElMessages(e.currentTarget)}
            size="small"
          >
            <Badge
              badgeContent={unreadMessages.length}
              color="error"
              showZero={false}
            >
              <MessageIcon sx={{ fontSize: 22, color: '#5f6368' }} />
            </Badge>
          </IconButton>

          <Menu
            anchorEl={anchorElMessages}
            open={Boolean(anchorElMessages)}
            onClose={() => setAnchorElMessages(null)}
            PaperProps={{
              sx: { width: 320, mt: 1.5, borderRadius: '12px', p: 1 },
            }}
          >
            <Box
              sx={{
                p: 1.5,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Typography sx={{ fontWeight: 800, color: '#2B3674' }}>
                Messages récents
              </Typography>
              <Chip
                label={unreadMessages.length}
                size="small"
                color="primary"
                sx={{ fontSize: '0.7rem' }}
              />
            </Box>
            <Divider />

            <List sx={{ p: 0, maxHeight: 300, overflow: 'auto' }}>
              {unreadMessages.length === 0 ? (
                <Box sx={{ p: 3, textAlign: 'center' }}>
                  <DraftsIcon sx={{ color: '#A3AED0', mb: 1 }} />
                  <Typography variant="body2" color="textSecondary">
                    Aucun nouveau message
                  </Typography>
                </Box>
              ) : (
                unreadMessages.slice(0, 5).map((msg) => (
                  <MenuItem
                    key={msg.id}
                    onClick={() => {
                      setAnchorElMessages(null);
                      navigate('/messages');
                    }}
                    sx={{
                      borderRadius: '8px',
                      mb: 0.5,
                      alignItems: 'flex-start',
                      py: 1.5,
                    }}
                  >
                    <Avatar
                      sx={{
                        width: 32,
                        height: 32,
                        mr: 1.5,
                        bgcolor: '#F4F7FE',
                        color: '#4318FF',
                        fontSize: '0.8rem',
                      }}
                    >
                      {msg.name?.charAt(0)}
                    </Avatar>
                    <ListItemText
                      primary={
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: 700, color: '#2B3674' }}
                        >
                          {msg.name}
                        </Typography>
                      }
                      secondary={
                        <Typography
                          variant="caption"
                          sx={{
                            display: 'block',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          {msg.content}
                        </Typography>
                      }
                    />
                  </MenuItem>
                ))
              )}
            </List>

            <Divider sx={{ my: 1 }} />
            <Button
              fullWidth
              size="small"
              onClick={() => {
                setAnchorElMessages(null);
                navigate('/messages');
              }}
              sx={{ textTransform: 'none', fontWeight: 700, color: '#4318FF' }}
            >
              Voir tous les messages
            </Button>
          </Menu>

          {/* Traduction */}
          <IconButton size="small">
            <LanguageIcon sx={{ fontSize: 22, color: '#5f6368' }} />
          </IconButton>

          {/* Notifications */}
          <IconButton
            onClick={(e) => setAnchorElNotif(e.currentTarget)}
            size="small"
          >
            <Badge badgeContent={3} color="error" variant="dot">
              <NotificationsIcon sx={{ fontSize: 24, color: '#5f6368' }} />
            </Badge>
          </IconButton>

          <Divider orientation="vertical" flexItem sx={{ mx: 1, my: 2 }} />

          {/* Profil */}
          <Box
            sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
            onClick={(e) => setAnchorElUser(e.currentTarget)}
          >
            {!isMobile && (
              <>
                {/* --- TOGGLE DISPONIBILITÉ (DESIGN MODERNE) --- */}
                {isIntervenant && (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      bgcolor: isOnline ? '#f0fff4' : '#fff5f5', // Fond très léger
                      border: '1.5px solid',
                      borderColor: isOnline ? '#05CD99' : '#F44336',
                      borderRadius: '16px', // Coins très arrondis (style Bento)
                      px: 3,
                      py: 1,
                      mr: 3,
                      minWidth: '220px', // Plus large pour s'imposer
                      boxShadow: isOnline
                        ? '0 10px 15px -3px rgba(5, 205, 153, 0.15)'
                        : 'none',
                      transition:
                        'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                      ...statusPulse,
                    }}
                  >
                    {/* Indicateur visuel circulaire animé */}
                    <Box
                      sx={{
                        width: 12,
                        height: 12,
                        borderRadius: '50%',
                        bgcolor: isOnline ? '#05CD99' : '#F44336',
                        mr: 2,
                        animation: isOnline
                          ? 'pulse-green 2s infinite'
                          : 'none',
                      }}
                    />

                    <Box sx={{ flexGrow: 1 }}>
                      <Typography
                        sx={{
                          fontSize: '0.7rem',
                          fontWeight: 900,
                          color: isOnline ? '#05CD99' : '#F44336',
                          textTransform: 'uppercase',
                          letterSpacing: '1px',
                          lineHeight: 1,
                        }}
                      >
                        Statut Live
                      </Typography>
                      <Typography
                        variant="h6"
                        sx={{
                          fontSize: '1rem',
                          fontWeight: 800,
                          color: '#2B3674', // Ton bleu marine pro
                          lineHeight: 1.2,
                        }}
                      >
                        {isOnline ? 'En ligne' : 'Sur RDV'}
                      </Typography>
                    </Box>

                    <Divider
                      orientation="vertical"
                      flexItem
                      sx={{ mx: 2, height: '30px', alignSelf: 'center' }}
                    />

                    {isStatusLoading ? (
                      <CircularProgress size={24} sx={{ color: '#4318FF' }} />
                    ) : (
                      <Switch
                        checked={isOnline}
                        onChange={handleToggleStatus}
                        sx={{
                          width: 50,
                          height: 28,
                          padding: 0,
                          '& .MuiSwitch-switchBase': {
                            padding: '4px',
                            '&.Mui-checked': {
                              transform: 'translateX(22px)',
                              color: '#fff',
                              '& + .MuiSwitch-track': {
                                backgroundColor: '#05CD99',
                                opacity: 1,
                              },
                            },
                          },
                          '& .MuiSwitch-thumb': {
                            width: 20,
                            height: 20,
                            boxShadow: '0 4px 6px rgba(0,0,0,0.2)',
                          },
                          '& .MuiSwitch-track': {
                            borderRadius: 14,
                            backgroundColor: '#E0E5F2',
                            opacity: 1,
                          },
                        }}
                      />
                    )}
                  </Box>
                )}
                <Box sx={{ textAlign: 'right', mr: 1.5 }}>
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 600, lineHeight: 1.2 }}
                  >
                    {user.name}
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    {user.role === 1 || user.role === 2
                      ? 'Administrateur'
                      : 'Intervenant'}
                  </Typography>
                </Box>
              </>
            )}

            <Avatar
              sx={{
                width: 35,
                height: 35,
                bgcolor: '#3b82f6',
                fontSize: '0.9rem',
                fontWeight: 'bold',
              }}
            >
              {user.name?.charAt(0).toUpperCase()}
            </Avatar>
          </Box>

          {/* Menu Profil et Notifications (identiques à avant) */}
          <Menu
            anchorEl={anchorElNotif}
            open={Boolean(anchorElNotif)}
            onClose={() => setAnchorElNotif(null)}
            PaperProps={{ sx: { width: 250, mt: 1.5, borderRadius: '12px' } }}
          >
            <Box sx={{ p: 2, fontWeight: 'bold' }}>Notifications</Box>
            <Divider />
            <MenuItem sx={{ fontSize: '0.85rem' }}>
              Mise à jour du système
            </MenuItem>
          </Menu>

          <Menu
            anchorEl={anchorElUser}
            open={Boolean(anchorElUser)}
            onClose={() => setAnchorElUser(null)}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            PaperProps={{ sx: { width: 200, mt: 1.5, borderRadius: '12px' } }}
          >
            <MenuItem
              onClick={() => {
                setAnchorElUser(null);
                navigate('/mon-profil');
              }}
            >
              <ListItemIcon>
                <PersonIcon fontSize="small" />
              </ListItemIcon>
              Mon Profil
            </MenuItem>
            <Divider />
            <MenuItem onClick={logout} sx={{ color: '#d32f2f' }}>
              <ListItemIcon>
                <LogoutIcon fontSize="small" sx={{ color: '#d32f2f' }} />
              </ListItemIcon>
              Déconnexion
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default AppHeader;
